<div class="no-data-container" [ngClass]="class" *ngIf="class !== 'grey'">
    <img [src]="'svg/no-data-no-text.svg' | assetVersion" alt="No data" class="no-data-image">
    <span class="no-data-text">{{message}}</span>
</div>